import { get } from "@/utils/utils";

export interface SportEventCardState {
    guessList: any[];
    guess: any;
    aggregateGuesses: any[];
    aggregateSelectedIndex: number;
    showAggregatePredictions: boolean;
    showMatchupSection: boolean;
    isPromotedEvent: boolean;
    shouldRender: boolean;
}

const isMainGuess = ( guess: any ) => {
    return Number( get( guess, "mainFlag", 0 ) ) === 1;
};

const hasGuessGroupNo = ( guess: any ) => {
    return !!get( guess, "guessGroupNo", "" );
};

export function resolveSportEventCardState( eventInfo: any, selectedGuessIndex: number ): SportEventCardState {
    const rawGuessList = get( eventInfo, "guessList", [] );
    const guessList = Array.isArray( rawGuessList ) ? rawGuessList : [];
    const mainGuess = guessList.find( isMainGuess ) || null;
    const fallbackGuess = mainGuess || guessList[0] || {};
    const aggregateGuesses = guessList.filter( hasGuessGroupNo );
    const showAggregatePredictions = aggregateGuesses.length > 1;
    const aggregateSelectedIndex = showAggregatePredictions
        ? Math.min( Math.max( selectedGuessIndex, 0 ), aggregateGuesses.length - 1 )
        : 0;
    const guess = showAggregatePredictions
        ? ( aggregateGuesses[aggregateSelectedIndex] || aggregateGuesses[0] || {} )
        : fallbackGuess;
    const isPromotedEvent = !showAggregatePredictions && isMainGuess( guess );

    return {
        guessList,
        guess,
        aggregateGuesses,
        aggregateSelectedIndex,
        showAggregatePredictions,
        showMatchupSection: isPromotedEvent,
        isPromotedEvent,
        shouldRender: guessList.length > 0,
    };
}
